import { 
    distanceBetweenDots, 
    distanseBetweenLayers, 
    getCenteredCoordinateForAnimation, 
    getNotCenteredCoordinateForAnimationByAngle, 
    BallPositionByDot,
    parabolic,
    PARABOLIC_ANIMATION_TIME,
    getTimeByLayers
 } from '../../initials';
export class ParabolicAnimationTopRightCenter {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: true,
            type: 'ParabolicAnimationTopRightCenter',
            fromBallPositionByDot: BallPositionByDot.TOP_RIGHT,
            toBallPositionByDot: BallPositionByDot.CENTER,
        };
    }

    getAnimationTime() {
        return getTimeByLayers(this.toRowIndex, this.fromRowIndex, PARABOLIC_ANIMATION_TIME);
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const isLeftMovement = this.fromDotIndex >= this.toDotIndex;
        const isMostThenOneLevel = this.toRowIndex - this.fromRowIndex > 1;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const middleDot = isLeftMovement ? this.dots[this.fromRowIndex][this.fromDotIndex - 1] : this.dots[this.fromRowIndex][this.fromDotIndex + 1];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getNotCenteredCoordinateForAnimationByAngle(startDot.dotX, startDot.dotY, Math.PI / 4);
        const endXY = getCenteredCoordinateForAnimation(endDot.dotX, endDot.dotY);

        return {
            x: parabolic(
                startXY.x, 
                isMostThenOneLevel ? middleDot.dotX : isLeftMovement ? middleDot.dotX + distanceBetweenDots / 2 : middleDot.dotX - distanceBetweenDots / 2, 
                endXY.x, 
                Math.pow(t, 1),
            ),
            y: parabolic(
                startXY.y, 
                isMostThenOneLevel ? middleDot.dotY : middleDot.dotY - distanseBetweenLayers / 2, 
                endXY.y, 
                Math.pow(t, 1),
            ),
        };
    }
}